import { FC, useCallback, KeyboardEvent } from 'react';

import {
  TextField,
  TextFieldProps,
} from '@beeline/design-system-react/extracted-styles';

export interface NumberFieldProps extends Omit<TextFieldProps, 'type'> {
  integer?: boolean;
  positive?: boolean;
}

export const NumberField: FC<NumberFieldProps> = ({
  integer = false,
  positive = false,
  onKeyDown,
  ...rest
}) => {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent<HTMLInputElement>) => {
      if ((integer && event.key === '.') || (positive && event.key === '-'))
        event.preventDefault();
      onKeyDown?.(event);
    },
    [integer, onKeyDown, positive],
  );

  return <TextField {...rest} onKeyDown={handleKeyDown} />;
};
